import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from 'src/app/core/store/store';
import { User } from 'src/app/shared/models/user.model';
import { DashboardService } from 'src/app/shared/services/dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { HandleSubscription } from 'src/app/shared/utils/handle-subscription';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subscription } from 'rxjs';
import { EventsService } from 'src/app/shared/services/events.service';

@Component({
  selector: 'app-dashboard-program',
  templateUrl: './dashboard-program.component.html',
  styleUrls: ['./dashboard-program.component.scss']
})
export class DashboardProgramComponent implements OnInit, OnDestroy {
  @Input() program: any;
  prog: any;
  user: User;
  showMobal = false;
  modelValue = false;
  modalData: any;
  dateFormat = 'h:mm a, d MMM y';
  courseStartParams: any;
  zoomStartParams: any;
  zoomSubscription: Subscription;
  courseSubscription: Subscription;
  lockedCardMsg =  { msg: '', date: null, courseName: '', courseId: null, type: '' };
  showMasterclass = false;
  masterClassModalData;
  masterVideoObj;
  @Input() isProgramCompletionDatePassed;

  constructor(private dashboardService: DashboardService, private router: Router, private toaster: ToastrService, private store: Store, private eventsService: EventsService) {
  }

  ngOnInit(): void {
    if (this.program.length) {
      this.addMasterClassEndDate();
      this.lockMsgOnCard();
    }
    this.store.select('user').subscribe((user: any) => {
      this.user = user;
    });

    this.courseSubscription = this.store.select('courseStart').subscribe((courseStart: any) => {
      if (courseStart) {
        this.courseStartParams = courseStart;
        this.startCourse(courseStart.type, courseStart.courseId, courseStart.progDashboardId, courseStart.item);
      }
    });

    this.zoomSubscription = this.store.select('zoomStart').subscribe((zoomStart1: any) => {
      if (zoomStart1) {
        this.zoomStartParams = zoomStart1;
        this.startZoom(this.zoomStartParams.masterClassObjectId, this.zoomStartParams.progDashboardId, this.zoomStartParams.item)
      }
    });
  }
  navigateToPreTest(item?) {
    this.router.navigate([`/benchmarking/pre-test`]);
     // capture event
    try {   
      this.capturePreTestEvents(item);
    } catch (err) {
      console.log(err);  
    }
  }
  openModal(value, item) {
    this.modelValue = value;
    if (this.modelValue) {
      let courseObj;
      if (this.courseStartParams) {
        // if course started from banner 
        courseObj = { activationId: this.courseStartParams.activationId, programDashboardId: this.courseStartParams.programDashboardId, activationDashboardType: 'COURSE', courseId: this.courseStartParams.courseId };
      } else {
        // if course started from card
        courseObj = { activationId: this.prog.activation._id, programDashboardId: item.programDashboardId, activationDashboardType: 'COURSE', courseId: item.courseId };
      }
      this.dashboardService.startCourse(courseObj).subscribe((res) => {
        if (res.data) {
          const url = this.router.serializeUrl(
            this.router.createUrlTree([`/player/${item.courseId}`])
          );
          window.open(url, '_blank');
          // capture event
          this.captureStartCourseEvent(item);
        }
      })

    }
  }


  showModal(item) {
    this.modalData = item;
    this.showMobal = true;
    // capture event
    try {
      if(this.user && this.prog) {
        let eventData = { user: this.user, program: this.prog };
        let courseObj = this.prog.dashboard.find(x => x.type == 'COURSE' && x._id == item._id);
        if(courseObj) {
          eventData['courseObj'] = courseObj;
        }
        this.eventsService.watchCourseIntroEvent(eventData);
      }      
    } catch (err) {
      console.log(err);  
    } 
  }

  navigateToPostTest(item?) {
    this.router.navigate([`/benchmarking/post-test`]);
    try {   
      this.capturePostTestEvents(item);
    } catch (err) {
      console.log(err);  
    }
  }

  startCourse(type, courseId, progDashboardId, el, event?) {
    if(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    if (!el.status.started) {
      this.modalData = el;
      this.showMobal = true;
      return;
    }
    if (this.modelValue) {
      let courseObj = { activationId: this.prog.activation._id, programDashboardId: progDashboardId, activationDashboardType: type, courseId: courseId };
      this.dashboardService.startCourse(courseObj).subscribe((res) => {
        if (res && res.data) {
          this.getProgramActivation();
          const url = this.router.serializeUrl(
            this.router.createUrlTree([`/player/${courseId}`])
          );
          window.open(url, '_blank');
          // capture event
          this.captureStartCourseEvent(el);
        }
      })
    }
    if (el.status.started) {
      // capture event
      this.captureResumeReviseCourseEvent(el);
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/player/${courseId}`])
      );
      window.open(url, '_blank'); 
    }
  }

  startZoom(masterClassObjectId, progDashboardId, item) {
    if ((item && item.status && item.status.islock) || item.status.upcoming || (item.status.isMeetingEnd && (!item.recordedLink || item.recordedLink == ''))) {
      return;
    }
    if((item.status.isMeetingEnd && item.recordedLink) || (item.recordedLink && item.recordedLink != '')) {
      if (this.zoomStartParams) {
        // if meeting started from banner 
        this.masterVideoObj = { activationId: this.zoomStartParams.activationId, programDashboardId: this.zoomStartParams.programDashboardId, activationDashboardType: 'MASTERCLASS', masterClassObjectId: this.zoomStartParams.item.masterClassObjects[0]._id, viewedTime: item.viewedTime };
      } else {
        this.masterVideoObj = { activationId: this.prog.activation._id, programDashboardId: progDashboardId, activationDashboardType: 'MASTERCLASS', masterClassObjectId: masterClassObjectId, viewedTime: item.viewedTime };
      }
      this.masterClassModalData = item;
      console.log(this.masterClassModalData, '')
      this.showMasterclass = true;
      
      // capture video watch event 
      try {   
        this.captureWatchMasterclassVideoEvent(item);
      } catch (err) {
        console.log(err);  
      }
    }
    // master class start api  
    else if (!item.status.started || (!item.status.isMeetingEnd && (item.status.progress < 100) && item.status.started)) {
      
      let masterObj;
      if (this.zoomStartParams) {
        // if meeting started from banner 
        masterObj = { activationId: this.zoomStartParams.activationId, programDashboardId: this.zoomStartParams.programDashboardId, activationDashboardType: 'MASTERCLASS', masterClassObjectId: this.zoomStartParams.item.masterClassObjects[0]._id };
      } else {
        // if meeting started from card
        masterObj = { activationId: this.prog.activation._id, programDashboardId: progDashboardId, activationDashboardType: 'MASTERCLASS', masterClassObjectId: masterClassObjectId };
      }
      this.store.set('zoomStart', null)
      // this.zoomSubscription && this.zoomSubscription.unsubscribe();
      this.dashboardService.startMasterclass(masterObj).subscribe((res) => {
        if (res && res.data) {
          this.getProgramActivation();
          this.startZoomMeeting(item);
        }
      });
    } else {
      
      this.startZoomMeeting(item);
    }

  }

  startZoomMeeting(item) {
    let meetingNum;
    // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    //   this.toaster.info("Please log in through your laptop/desktop to access this session");
    //   return;
    // }
    if (item && item.masterClassObjects.length) {
      meetingNum = item.masterClassObjects[0].meetingId;
      // get zoom meeting signature from API 
      this.generateZoomSign(meetingNum, item);   
    }
  }

  generateZoomSign(meetingNum, item?) {
    this.dashboardService.generateZoomSignature({meetingNumber: meetingNum, role: 0}).subscribe((res) => {
      if(res && res.data && res.data.signature) {
        localStorage.setItem('zoomSign', res.data.signature);
        this.zoomMeetingDataSet(meetingNum, item);
      } else {
        this.zoomMeetingDataSet(meetingNum, item);
      } 
    }, (error) => {
      console.log(error);
      this.zoomMeetingDataSet(meetingNum, item);
      // this.toaster.error("Zoom signature issue");
    });
  }

  zoomMeetingDataSet(meetingNum, item?) {
    localStorage.setItem('email', this.user.email);
    localStorage.setItem('meetingId', meetingNum);
    localStorage.setItem('userName', `${this.user.firstName} ${this.user.lastName}`);
    localStorage.setItem('pathwayUrl', window.location.href);
    window.open(`/zoom-meeting`, '_blank');
    // capture event
    try {   
      this.captureAttendMasterclassEvent(item);
    } catch (err) {
      console.log(err);  
    }
  }

  closeModel(value) {
    if (value) {
      this.store.set('courseStart', null);
      this.showMobal = false;
      this.openModal(value, this.modalData)
    } else {
      this.showMobal = value;
      // capture event course close modal
      try {   
        this.captureStopCourseIntroEvent();
      } catch (err) {
        console.log(err);  
      }
    }
  }

  navigateLinkedIn(url) {
    window.open(url, '_blank');
  }

  habitDrillDetails(item) {
    if (item && item?.courseHabitDrills[0] && item?.courseHabitDrills[0].courseHabitDrillId) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/dashboard/habit-drills/${item?.courseHabitDrills[0].courseHabitDrillId}`])
      );
      window.open(url, '_blank');
      // capture event
      try {
        if(this.user && this.program && this.program[0]) {
          let eventData = { user: this.user, activationData: this.program[0], item: item }
          this.eventsService.habitDrillTaggedEvent(eventData);
        } 
      } catch (err) {
        console.log(err);  
      }
    }
  }

  getProgramActivation() {
    this.store.set('courseStart', null);
    this.dashboardService.getProgramActivation().subscribe((res) => {
      if (res && res['data']) {
        this.store.set('activation', res['data']);
      }
    });
  }

  lockMsgOnCard() {
    let courses = [],
      lockedCourses = [],
      unLockedCourses = [];

    courses = this.prog.filter(v => v.type == 'COURSE');

    courses = courses.sort((a, b) => a.order - b.order);
    lockedCourses = courses.filter(v => v.status.islock == true);
    unLockedCourses = courses.filter(v => v.status.islock == false);
    let preAssessment = this.prog.benchmarkingAssessments ? this.prog.benchmarkingAssessments.find(v => v.exerciseType == 'PRE') : {};
    
    if ((courses.length == lockedCourses.length) && courses.length > 0) {
      if(preAssessment && (preAssessment.status.progress == 100) && this.prog.activation.courseUnlockType == 'DATE') {
        this.lockedCardMsg.msg = `This course will unlock on`;
        this.lockedCardMsg.courseId = lockedCourses[0].courseId;
        this.lockedCardMsg.date = new Date(lockedCourses[0].course_StartDate);
        this.lockedCardMsg.type = 'DATE';
      } else if (preAssessment && (preAssessment.status.progress != 100) && this.prog.activation.courseUnlockType == 'DATE') {
        if(new Date().getTime() > new Date(lockedCourses[0].course_StartDate).getTime()) {
          this.lockedCardMsg.msg = 'This course will unlock after completing the basecamp';
          this.lockedCardMsg.courseId = lockedCourses[0].courseId;
          this.lockedCardMsg.type = 'PRE';
        } else {
          this.lockedCardMsg.msg = `This course will unlock on`;
          this.lockedCardMsg.courseId = lockedCourses[0].courseId;
          this.lockedCardMsg.date = new Date(lockedCourses[0].course_StartDate);
          this.lockedCardMsg.type = 'DATE';
          this.lockedCardMsg['dateNotPassed'] = true;
        }
      } 
      else {
        this.lockedCardMsg.msg = 'This course will unlock after completing the basecamp';
        this.lockedCardMsg.courseId = lockedCourses[0].courseId;
        this.lockedCardMsg.type = 'PRE';
      }
    } else if (((lockedCourses.length > 0) && (lockedCourses.length < courses.length)) && this.prog.activation.courseUnlockType == 'SEQUENCE') {
      if (unLockedCourses.length > 0) {
        this.lockedCardMsg.msg = `Complete ${unLockedCourses[unLockedCourses.length - 1].title} to unlock this course`;
        this.lockedCardMsg.courseId = lockedCourses[0].courseId;
        this.lockedCardMsg.type = 'SEQUENCE';
        this.lockedCardMsg.courseName = unLockedCourses[unLockedCourses.length - 1].title;
      }
    } else if (((lockedCourses.length > 0) && (lockedCourses.length < courses.length)) && this.prog.activation.courseUnlockType == 'DATE') {
      this.lockedCardMsg.msg = `This course will unlock on`;
      this.lockedCardMsg.courseId = lockedCourses[0].courseId;
      this.lockedCardMsg.date = new Date(lockedCourses[0].course_StartDate);
      this.lockedCardMsg.type = 'DATE';
    }
    this.compareDate();
  }

  compareDate() {
    if(this.prog.activation && this.prog.activation.courseUnlockType == 'DATE') {
      let preAssessment = this.prog.benchmarkingAssessments.find(v => v.exerciseType == 'PRE');
      this.prog.dashboard.map((c) => {
        if(c.type == 'COURSE')
        c['isDatePassed'] =  new Date().getTime() > new Date(c.course_StartDate).getTime();
        c['isPreDone'] = (preAssessment && (preAssessment.status.progress == 100)) ? true : false;
      });
    }
  }

  closeMasterClassModal(value) {
    this.showMasterclass = false;
    if(value) {
      window.location.reload();
    } else {
      this.getProgramActivationOnZoom();
      this.store.set('zoomStart', null);
    }
  }

  getProgramActivationOnZoom() {
    this.dashboardService.getProgramActivation().subscribe((res) => {
      if (res && res['data']) {
        this.prog = res['data'][0]['program'];
        this.store.set('activation', res['data']);
      }
    });
  }
  

  goToReportCertificate() {
    if(this.program && this.program[0] && this.program[0].progress && (this.program[0].progress == 100) && this.program[0].isFeedbackSubmitted) {
      this.router.navigate(['/dashboard/reports-certificate']);
      //  capture event
      try {   
        if(this.user && this.program[0]) {
          let eventData = { user: this.user, activationData: this.program[0] };
          this.eventsService.viewCertificateTranscriptEvent(eventData);
        }
      } catch (err) {
        console.log(err);  
      }
    } else {
      return;
    }
  }


  ngOnDestroy() {
    this.store.set('courseStart', null);
    this.store.set('zoomStart', null)
    this.courseSubscription && this.courseSubscription.unsubscribe();
    this.zoomSubscription && this.zoomSubscription.unsubscribe();
  }

  addMasterClassEndDate() {
    // find masterclass endDate from duration 
    this.program.map((v) => {
      if(v.type == "MASTERCLASS" && v.masterClassObjects && v.masterClassObjects.length) {
        v.masterClassObjects[0].endDate = this.addMinutes(new Date(v.masterClassObjects[0].date), +v.duration);
      }
    });
    this.prog = this.program;
  }

  addMinutes(date, minutes) {
    // convert minutes to miliseconds
    return new Date(date.getTime() + minutes*60000);
  }

  capturePreTestEvents(item?) {
    if(this.user && this.prog && item) {
      let eventData = { user: this.user, program: this.prog, item: item }
      if(item.status.started && item.status.progress < 100){
        this.eventsService.resumePreTestEvent(eventData);
      }
      else if (item.status.progress == 100) {
        this.eventsService.viewFeedbackPreTestEvent(eventData);
      }
      else {
        this.eventsService.startPreTestEvent(eventData);
      }
    }
  }

  capturePostTestEvents(item) {
    if(this.user && this.prog && item) {
      let eventData = { user: this.user, program: this.prog, item: item }
      if(item.status.started && item.status.progress < 100) {
        this.eventsService.resumePostTestEvent(eventData);
      }
      else if (item.status.progress == 100) {
        this.eventsService.viewFeedbackPostTestEvent(eventData);
      }
      else {
        this.eventsService.startPostTestEvent(eventData);
      }
    }
  }

  captureStartCourseEvent(item) {
    try {   
      if(this.user && this.program && this.program[0] && item) {
        let eventData = { 'course': item, 'user': this.user, 'program': this.program[0].program };
        this.eventsService.startCourseEvent(eventData);
      }
    } catch (err) {
      console.log(err);  
    }
  }

  captureResumeReviseCourseEvent(item) {
    try {
      if(this.user && (this.program && this.program[0]) && item) {
        let eventData = { user: this.user, course: item, activationData: this.program[0] }
        if(item.status.progress == 100) {
          this.eventsService.reviseCourseEvent(eventData);
        }
        else if (item.status.progress < 100) {
          this.eventsService.resumeCourseEvent(eventData);
        }
      }
    } catch (err) {
      console.log(err); 
    }
  }

  captureAttendMasterclassEvent(item) {
    if(this.user && this.prog && item) {
      let eventData = { user: this.user, program: this.prog }
      let masterclass = this.prog.dashboard.find( x => ((x.type == 'MASTERCLASS') && (x._id == item._id)))
      if(masterclass) { 
        eventData['masterclassObj'] = masterclass; 
      }
      this.eventsService.attendMasterclassEvent(eventData);
    }
  }

  captureWatchMasterclassVideoEvent(item?) {
    if(this.user && this.prog) {
      let eventData = { user: this.user, program: this.prog }
      let masterclass = this.prog.dashboard.find( x => (x.type == 'MASTERCLASS') && (x._id == item._id));
      if(masterclass){
        eventData['masterclassObj'] = masterclass;
      }
      this.eventsService.watchMasterclassVideoEvent(eventData);
    }
  }

  captureStopCourseIntroEvent() {
    if(this.user && this.prog) {
      let eventData = { user: this.user, program: this.prog };
      let courseObj = this.prog.dashboard.find(x => (x.type == 'COURSE') && (x._id == this.modalData._id));
      if(courseObj) {
        eventData['courseObj'] = courseObj;
      }
      this.eventsService.stopCourseIntroEvent(eventData);
    }
  }

  masterclassDetailsEvent(e, item) {
    try {   
      if(e && this.user && this.prog && item) {
        let eventData = { user: this.user, prog: this.prog, masterclass: item };
        this.eventsService.seeMasterclassDetailsEvent(eventData);
      }
    } catch (err) {
      console.log(err);  
    }
  }
}
